import FlightStatusDetails from './FlightStatusDetails';

export default FlightStatusDetails;
